import { render, staticRenderFns } from "./sidebarcomp.vue?vue&type=template&id=0f51dbfa&scoped=true&"
import script from "./sidebarcomp.vue?vue&type=script&lang=js&"
export * from "./sidebarcomp.vue?vue&type=script&lang=js&"
import style0 from "./sidebarcomp.vue?vue&type=style&index=0&id=0f51dbfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51dbfa",
  null
  
)

export default component.exports